<template>
  <div class="serveIndex">
    <LoadingModal bgcolor="transparent" />
    <div>
      <IndexUser
        :banner="banner"
        :exchangeService="exchange_service"
        :changeService="change_service"
        :recoveryService="recovery_service"
        :offlineList="offline_service"
        :userInfo="userInfo"
        :waitPayOrdersCount="waitPayOrdersCount"
        ref="banner"
      />
    </div>
  </div>
</template>
<script>
import IndexUser from "./IndexUser";
import defaultdata from "server/data/server.json";
import { wechatAuth } from "api/auth";
import {
  getUserInfo,
  // getUnreceivedCouponsCount,
  getUserWaitPayOrdersCount,
} from "api/user";
import { getAllServerList } from "api/onLine";
import { Dialog } from "vant";

export default {
  components: {
    IndexUser,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      banner: [],
      //兑换服务
      exchange_service: [],
      //红包、零钱服务
      change_service: [],
      //转让服务
      recovery_service: [],

      offline_service: [],
      userInfo: {},
      lgImg: require("assets/u10.png"),
      listImg: require("assets/car.jpg"),
      authCount: 0,
      firstOnLoad: true,
      waitPayOrdersCount: 0,
    };
  },
  created() {
    if (this.$getItem("config") != undefined) {
      const obj = this.$getItem("config")
      try {
        // this.$getItem("config").banner.forEach((element) => {
        //   console.warn(element)
        //   this.banner.push(require("@/assets/" + element + ".jpg"));
        // });
        if (obj.banner) {
          this.banner.push(require("@/assets/" + obj.banner + ".jpg"));
        }
      } catch (err) {console.error(err)}
    }
  },
  mounted() {
    this.auth();
    this.$store.commit("setPageLoading", false);
    // this.getServerList();
    // this.getWaitPayOrdersCount();
  },
  methods: {
    auth() {
      let isAuth = this.$getItem("isAuth");
      let code = this.$route.query.code;
      let state = this.$route.query.state;

      if (isAuth == undefined || code != undefined) {
        wechatAuth(code, state).then((res) => {
          this.authCount = 1;
          if (res.status == 200) {
            this.$setItem("isAuth", 1);
            this.getUserInfo();
          } else {
            this.$error(res.message);
          }
        });
      } else {
        this.getUserInfo();
      }
    },
    getUserInfo() {
      var that = this;
      let code = this.$route.query.code;
      let state = this.$route.query.state;
      getUserInfo().then((res) => {
        if (res.status == 200) {
          that.userInfo = res.data;
          if (that.userInfo.userPhone != undefined) {
            this.$setItem("userModel", res.data);
            this.getServerList();
            // this.getUnreceivedCouponsCount();
            this.getWaitPayOrdersCount();
          } else {
            that.$push({
              path: "/register",
            });
          }
        } else if (res.status == 400) {
          if (that.firstOnLoad) {
            that.firstOnLoad = false;
            wechatAuth(code, state).then((res) => {
              this.authCount = 1;
              if (res.status == 200) {
                this.$setItem("isAuth", 1);
                this.getUserInfo();
              }
            });
          }
        } else {
          if (this.authCount < 1) {
            this.$removeItem("isAuth");
            this.auth;
          }
          this.$error(res.message);
        }
      });
    },
    getServerList() {
      getAllServerList().then(res => {
        if (res.status === 200) {
          for (let index = 0; index < defaultdata.recharge_service.length; index++) {
            const item = defaultdata.recharge_service[index];
            if(['examined', 'parking','lifeService','transport'].includes(item.link)) {
              continue;
            }
            if (res.data && res.data.serverList) {
              let obj = res.data.serverList.find(i => i.categoryIdentification == item.link)
              if (obj) {
                //  “在线教育”不判断 上架状态 和 库存状态
                if(['onlineEducation'].includes(item.link)){
                  item.stockStatus = 1
                }else if(obj.status != '1'){
                  continue;
                }else{
                  item.stockStatus = Number(obj.stockStatus);
                }
                item.id = obj.categoryId
              }
              if (res.data.mouldIds) item.couponsMouldId = res.data.mouldIds[0]
            }
            if(['weChatRedPacket', 'weChatPoints', 'alipayWithdraw', 'bankWithdraw'].includes(item.link)) {
              this.change_service.push(item);
            }else if(['recovery','alipayPoints'].includes(item.link)) {
              this.recovery_service.push(item);
            }else {
              this.exchange_service.push(item);
            }
          }
          for (let index = 0; index < defaultdata.offline_service.length; index++) {
            const element = defaultdata.offline_service[index];
            element.id = index;
            this.offline_service.push(element);
          }
        }
      })
    },
    getWaitPayOrdersCount() {
      getUserWaitPayOrdersCount().then((res) => {
        if (res.status == 200) {
          this.waitPayOrdersCount = res.data;
        } else {
          this.$error(res.message);
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.listPackage {
  img {
    border-radius: 5px;
    width: 100%;
    margin-bottom: 10px;
    box-shadow: #ccc 0 0 5px;
  }
}
.loading {
  z-index: 9999;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 100%;
  width: 100%;
  margin: 0;
  background-color: white;
  border: 1px solid white;
  div {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    span {
      color: var(--depYelColor);
    }
  }
  h5 {
    color: var(--depYelColor);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.indexUser {
  // background: linear-gradient(
  //   180deg,
  //   var(--depYelColor) 8%,
  //   var(--bgColor) 220px
  // );
  .userInfo {
    height: 64px;
    color: var(--activeColor);
    font-size: var(--pFont);
    .kimg {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 8px;
    }
    .name {
      font-weight: var(--defaultFontWeight);
      span {
        font-weight: normal;
        font-size: var(--spanFont);
      }
    }
    .balance {
      margin-left: auto;
      height: 34px;
      background: rgba(127, 80, 9, 0.16);
      padding: 0 14px;
      p:nth-of-type(2) {
        margin-left: 6px;
      }
      i {
        font-style: normal;
        vertical-align: middle;
      }
      span {
        vertical-align: middle;
        font-size: 20px;
        font-weight: var(--defaultFontWeight);
      }
    }
    @media screen and (max-width: 350px) {
      .balance {
        flex: 1;
        padding: 4px 6px;
        height: initial;
        p {
          text-align: center;
        }
      }
    }
  }
  .indexBannar {
    height: 122px;
    margin: 0 -20px;
  }
  .warning {
    margin-top: 25px;
  }
}
</style>
